import { css } from 'emotion'

export const marginLeftSmallStyles = css`
  margin-left: 8px;
`
